module.exports = __webpack_public_path__ + "img/179939.0cf464d8.png";